export const GET_CURRENT_DATE = "GET_CURRENT_DATE";
export const SET_DAYS = "SET_DAYS";
export const PREV_MONTH = "PREV_MONTH";
export const NEXT_MONTH = "NEXT_MONTH";
export const TOGGLE_DETAIL_SB = "TOGGLE_DETAIL_SB";
export const TOGGLE_EVENTS_SB = "TOGGLE_EVENTS_SB";
export const TOGGLE_NEW_EVENT_SB = "TOGGLE_NEW_EVENT_SB";
export const SET_DAY_DETAIL = "SET_DAY_DETAIL";
export const ADD_EVENT_DATE = "ADD_EVENT_DATE";
export const DELETE_EVENT = "DELETE_EVENT";
export const SET_EVENTS = "SET_EVENTS";
export const EDIT_EVENT = "EDIT_EVENT";
export const CHANGE_EVENT_FIELD = "CHANGE_SERVICE_FIELD";
export const CLEAR_EVENT_FIELD = "CLEAR_EVENT_FIELD";